import type { IconProps } from '../types/IconProps.ts';
export const PackageCheck: IconProps = {
    name: 'PackageCheck',
    children: [
        `<path d="m15.38 20.13-1.13.62-1.28.71a2 2 0 0 1-1.94 0l-7-3.89A2 2 0 0 1 3 15.82V8.18a2 2 0 0 1 1.03-1.75l7-3.89a2 2 0 0 1 1.94 0l7 3.89A2 2 0 0 1 21 8.18V11" />`,
        `<path d="m17 16 1.84 1.84a.2.2 0 0 0 .3-.02L22 14M3.5 7.5l7.56 4a2 2 0 0 0 1.88 0l7.56-4M12 12v9M8.5 4.5l8 5" />`,
    ]
};